import { Button, IconButton } from 'omakase';
import { Card, CardContent } from 'ui';
import { IconEdit } from '@tock/icons';
import { css } from '@emotion/react';

type EditButtonType = 'Pencil' | 'View';

interface Props {
  children: React.ReactNode;
  /**
   * Edit handler. Only used with a button if `editButtonType` is provided.
   */
  onClickEdit?(): void;
  /**
   * Visual style of the edit button.
   */
  editButtonType?: EditButtonType;
}

const cardStyles = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const SupplementGroupSummaryCard: React.FunctionComponent<Props> = ({
  children,
  onClickEdit,
  editButtonType,
}: Props) => {
  return (
    <Card variant="outlined">
      <CardContent css={cardStyles}>
        <div>{children}</div>
        {editButtonType === 'Pencil' ? (
          <IconButton variant="basic" size="medium" aria-label="edit" onClick={onClickEdit}>
            <IconEdit />
          </IconButton>
        ) : editButtonType === 'View' ? (
          <Button variant="primary" size="medium" aria-label="view" onClick={onClickEdit}>
            View
          </Button>
        ) : null}
      </CardContent>
    </Card>
  );
};

export default SupplementGroupSummaryCard;
